import React from "react";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import ReactCountryFlag from "react-country-flag";
import Validator from "../../../services/Validator";
import EnergoTooltip from "../../shared/Tooltip";

const InfoStage = ({ data, setData, errors, setErrors, checkData }) => {

    const VALIDATOR = new Validator();


    return (
        <div className="mt-3 text-start">
            <Row>
                <Col>
                    <fieldset>
                        <Form.Group as={Row}>
                            <Form.Text className="text-dark" as="legend" sm="12" xl="3">
                                <b>Ich bin...</b>
                            </Form.Text>
                            <Col>
                                <Form.Check
                                    name="company_typeId"
                                    type="radio"
                                    label="Privatperson"
                                    checked={data.company_type === "person"}
                                    onChange={() => setData(prev => ({ ...prev, company_type: "person", x_is_house_management: false, companyKw: false }))}
                                    isInvalid={errors.company_type}
                                />
                                <Form.Check
                                    name="company_typeId"
                                    type="radio"
                                    label="Gewerbebetrieb"
                                    checked={data.company_type === "company" && data.x_is_house_management === false}
                                    onChange={() => setData(prev => ({ ...prev, company_type: "company", x_is_house_management: false, companyKw: false }))}
                                    isInvalid={errors.company_type}
                                />
                                <Form.Check
                                    name="company_typeId"
                                    type="radio"
                                    label="Hausverwaltung"
                                    checked={data.x_is_house_management === true && data.company_type === "company"}
                                    onChange={() => setData(prev => ({ ...prev, company_type: "company", x_is_house_management: true, companyKw: true }))}
                                    isInvalid={errors.company_type}
                                />
                            </Col>
                        </Form.Group>
                    </fieldset>
                </Col>
            </Row>
            {!data.x_is_house_management && data.company_type === "company" ?
                <Row className="mt-3">
                    <fieldset>
                        <Form.Group as={Row}>
                            <Form.Text className="text-dark">
                                <b>Ich verbrauche pro Jahr mehr als 100.000 kWh Strom und/oder 400.000 kWh Gas</b>
                            </Form.Text>
                            <Col>
                                <Form.Check
                                    name="companyKw"
                                    type="radio"
                                    label="Ja"
                                    checked={data.companyKw === true}
                                    value={true}
                                    onChange={e => setData(prev => ({ ...prev, companyKw: true }))}
                                    isInvalid={errors.companyKw}
                                />
                                <Form.Check
                                    name="companyKw"
                                    type="radio"
                                    label="Nein"
                                    checked={data.companyKw === false}
                                    value={false}
                                    onChange={e => setData(prev => ({ ...prev, companyKw: false }))}
                                    isInvalid={errors.companyKw}
                                />
                            </Col>
                        </Form.Group>
                    </fieldset>
                </Row>
                : null}
            {data.companyKw === false ?
                <Row className="mt-3">
                    <Col>
                        <fieldset>
                            <Form.Group as={Row}>
                                <Form.Text className="text-dark" as="legend">
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <b style={{marginRight: 10}}>Ich will...</b>
                                    </div>
                                </Form.Text>
                                <Col>
                                    <Form.Check
                                        name="caseId"
                                        type="radio"
                                        label={<div style={{display: "flex", alignItems: "center"}}><span style={{marginRight: 10}}>Strom/Gas neu anmelden</span> <EnergoTooltip text={"Derzeit besteht kein laufender Energieliefervertrag auf meinen Namen. (z.B. Umzug)"} color={"text-warning"} style={{ lineHeight: "1", marginTop: "-2px" }}/></div>}
                                        checked={data.case === 5}
                                        value={5}
                                        onChange={e => setData(prev => ({ ...prev, case: 5 }))}
                                        isInvalid={errors.case}
                                    />
                                    <Form.Check
                                        name="caseId"
                                        type="radio"
                                        label={<div style={{display: "flex", alignItems: "center"}}><span style={{marginRight: 10}}>Strom/Gas-Vertrag wechseln</span> <EnergoTooltip text={"Es besteht ein laufender Energieliefervertrag auf meinen Namen."} color={"text-warning"} style={{ lineHeight: "1", marginTop: "-2px" }}/></div>}
                                        checked={data.case === 6}
                                        value={6}
                                        onChange={e => setData(prev => ({ ...prev, case: 6 }))}
                                        isInvalid={errors.case}
                                    />
                                </Col>
                            </Form.Group>
                        </fieldset>
                    </Col>
                </Row>
                :
                <>
                    <Row className="mt-3">
                        <h5>Kontaktaufnahme</h5>
                        <p style={{ fontSize: 14, fontWeight: 800 }} className="text-dark">
                            {data.x_is_house_management === true?
                                `Für Hausverwaltungen bieten wir individuelle Vertragslösungen und Dienstleistungen an. 
                                Dafür möchten wir gerne mehr zu Ihrer Situation erfahren. Bitte 
                                hinterlassen Sie Ihre Kontaktdaten. Wir nehmen in Kürze persönlich 
                                Kontakt mit Ihnen auf!`
                            :
                                `Für Abnehmer/innen mit Großanlagen bzw. einer Vielzahl von Anlagen 
                                bieten wir individuelle Vertragslösungen. Dafür möchten wir gerne 
                                mehr zu Ihrer Situation erfahren. Bitte hinterlassen Sie Ihre 
                                Kontaktdaten. Wir nehmen in Kürze persönlich Kontakt mit Ihnen auf!`
                            }
                        </p>
                    </Row>
                </>
            }
            {data.case === 6 && data.companyKw !== true ?
                <Row className="mt-3">
                    <h5>Strom/Gas-Vertrag wechseln</h5>
                    <p style={{ fontSize: 14, fontWeight: 800 }} className="text-dark">
                        Für einen bevorstehenden Wechsel erstellen wir Ihnen gerne ein
                        Vergleichsangebot und nehmen Kontakt mit Ihnen auf. Bitte
                        hinterlassen Sie hier Ihre Daten und stellen uns Ihre
                        aktuellste Jahresabrechnung zur Verfügung.
                    </p>
                </Row>
                : null}
            <Row className="mt-3 text-dark">
                <Col>
                    <FloatingLabel label={data.company_type === "company" ? "Unternehmensbezeichnung" : "Vorname"}>
                        <Form.Control
                            type="text"
                            placeholder={data.company_type === "company" ? "Unternehmensbezeichnung" : "Vorname"}
                            value={data.name}
                            onChange={e => { setErrors({}); setData(prev => ({ ...prev, name: e.target.value })) }}
                            isValid={data.name !== ""}
                            isInvalid={errors.name}
                        />
                    </FloatingLabel>
                </Col>
                <Col hidden={data.company_type === "company"}>
                    <FloatingLabel label="Nachname">
                        <Form.Control
                            type="text"
                            placeholder="Nachname"
                            value={data.lastName}
                            onChange={e => { setErrors({}); setData(prev => ({ ...prev, lastName: e.target.value })) }}
                            isValid={data.lastName !== ""}
                            isInvalid={errors.lastName}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            {data.companyKw ?
                <Row className="mt-3 text-dark">
                    <Col>
                        <FloatingLabel label="Ansprechperson">
                            <Form.Control
                                type="text"
                                placeholder="Ansprechperson"
                                value={data.contactPerson}
                                onChange={e => { setErrors({}); setData(prev => ({ ...prev, contactPerson: e.target.value })) }}
                                isValid={data.contactPerson !== ""}
                                isInvalid={errors.contactPerson}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                : null}
            <Row className="mt-3 text-dark">
                <Col>
                    <FloatingLabel label="E-Mail">
                        <Form.Control
                            type="email"
                            placeholder="E-Mail"
                            value={data.email}
                            onChange={e => { setErrors({}); setData(prev => ({ ...prev, email: e.target.value })) }}
                            isValid={VALIDATOR.EmailValid(data.email)}
                            isInvalid={errors.email}
                        />
                        <Form.Text className="text-danger" hidden={errors.email === undefined}>
                            {errors.email}
                        </Form.Text>
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-3 text-dark">
                <Col>
                    <Form.Group>
                        <FloatingLabel label="Ländercode">
                            <Form.Select
                                onChange={e => setData(prev => ({ ...prev, phone_country: e.target.value }))}
                                value={data.phone_country}
                            >
                                <option value="+43"><ReactCountryFlag countryCode="AT" /> +43</option>
                                <option value="+32"><ReactCountryFlag countryCode="BE" /> +32</option>
                                <option value="+359"><ReactCountryFlag countryCode="BG" /> +359</option>
                                <option value="+385"><ReactCountryFlag countryCode="HR" /> +385</option>
                                <option value="+357"><ReactCountryFlag countryCode="CY" /> +357</option>
                                <option value="+420"><ReactCountryFlag countryCode="CZ" /> +420</option>
                                <option value="+45"><ReactCountryFlag countryCode="DK" /> +45</option>
                                <option value="+372"><ReactCountryFlag countryCode="EE" /> +372</option>
                                <option value="+358"><ReactCountryFlag countryCode="FI" /> +358</option>
                                <option value="+33"><ReactCountryFlag countryCode="FR" /> +33</option>
                                <option value="+49"><ReactCountryFlag countryCode="DE" /> +49</option>
                                <option value="+30"><ReactCountryFlag countryCode="GR" /> +30</option>
                                <option value="+36"><ReactCountryFlag countryCode="HU" /> +36</option>
                                <option value="+354"><ReactCountryFlag countryCode="IS" /> +354</option>
                                <option value="+353"><ReactCountryFlag countryCode="IE" /> +353</option>
                                <option value="+39"><ReactCountryFlag countryCode="IT" /> +39</option>
                                <option value="+371"><ReactCountryFlag countryCode="LV" /> +371</option>
                                <option value="+423"><ReactCountryFlag countryCode="LI" /> +423</option>
                                <option value="+370"><ReactCountryFlag countryCode="LT" /> +370</option>
                                <option value="+352"><ReactCountryFlag countryCode="LU" /> +352</option>
                                <option value="+356"><ReactCountryFlag countryCode="MT" /> +356</option>
                                <option value="+31"><ReactCountryFlag countryCode="NL" /> +31</option>
                                <option value="+47"><ReactCountryFlag countryCode="NO" /> +47</option>
                                <option value="+48"><ReactCountryFlag countryCode="PL" /> +48</option>
                                <option value="+351"><ReactCountryFlag countryCode="PT" /> +351</option>
                                <option value="+40"><ReactCountryFlag countryCode="RO" /> +40</option>
                                <option value="+421"><ReactCountryFlag countryCode="SK" /> +421</option>
                                <option value="+386"><ReactCountryFlag countryCode="SI" /> +386</option>
                                <option value="+34"><ReactCountryFlag countryCode="ES" /> +34</option>
                                <option value="+46"><ReactCountryFlag countryCode="SE" /> +46</option>
                            </Form.Select>
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col>
                    <FloatingLabel label="Vorwahl">
                        <Form.Control
                            type="phone"
                            placeholder="Vorwahl"
                            value={data.vorwahl}
                            onChange={e => { setErrors({}); setData(prev => ({ ...prev, vorwahl: e.target.value })) }}
                            isValid={data.vorwahl !== "" && VALIDATOR.IsNumeric(data.vorwahl)}
                            isInvalid={errors.vorwahl}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="text-dark mt-3">
                <Col>
                    <FloatingLabel label="Telefonnummer">
                        <Form.Control
                            type="phone"
                            placeholder="Telefonnummer"
                            value={data.phone}
                            onChange={e => { setErrors({}); setData(prev => ({ ...prev, phone: e.target.value })) }}
                            isValid={data.phone !== "" && VALIDATOR.IsNumeric(data.phone)}
                            isInvalid={errors.phone}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            {data.companyKw ?
                <Row className="mt-3 text-dark">
                    <Col>
                        <FloatingLabel label="Zusätzliche Informationen">
                            <Form.Control
                                as="textarea"
                                placeholder="Zusätzliche Informationen"
                                style={{ height: 100 }}
                                value={data.comment}
                                onChange={e => setData(prev => ({ ...prev, comment: e.target.value }))}
                                isValid={data.comment !== ""}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>
                : null}
            {data.case === 6 && data.companyKw !== true ?
                <Row className="mt-3">
                    <Col>
                        <fieldset className="text-start">
                            <Form.Group
                                className="text-left mt-3 mb-5"
                                as={Row}
                            >
                                <Form.Text as="legend" className="text-dark">
                                    <b>
                                        Um Ihnen bestmöglich helfen zu können,
                                        möchten wir gerne wissen in welcher Situation
                                        Sie sich gerade befinden:
                                    </b>
                                </Form.Text>
                                <Col sm={12}>
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Vertragskündigung des Stromanbieters MIT Folgeangebot, Tariferhöhung"
                                        value="Vertragskündigung des Stromanbieters MIT Folgeangebot, Tariferhöhung"
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Vertragskündigung des Stromanbieters OHNE Folgeangebot"
                                        value="Vertragskündigung des Stromanbieters OHNE Folgeangebot"
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"

                                        label="Höheres Folgeangebot bereits angenommen"
                                        value="Höheres Folgeangebot bereits angenommen"
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Bevorstehender Umzug / Neuanmeldung"
                                        value="Bevorstehender Umzug / Neuanmeldung"
                                        defaultChecked
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Kürzlich umgezogen und einen teuren Neuvertrag abgeschlossen"
                                        value="Kürzlich umgezogen und einen teuren Neuvertrag abgeschlossen"
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Börsenabhängiger Flex-/Floattarif"
                                        value="Börsenabhängiger Flex-/Floattarif"
                                    />
                                    <Form.Check
                                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                                        type="radio"
                                        name="situationRadios"
                                        label="Keine der genannten"
                                        value="Keine der genannten"
                                    />
                                </Col>
                            </Form.Group>
                        </fieldset>
                    </Col>
                </Row>
                : null}
            <Row className="text-end mt-3">
                <Col>
                    <Button variant="warning" onClick={() => checkData()}>
                        {data.companyKw ? "Absenden" : data.case === 6? "Weiter" : "Registrieren"}
                    </Button>
                </Col>
            </Row>
        </div>
    )
}
export default InfoStage;